const pollutants = [
  { name: "Smoke & Fine Particulate Matter", percent: 99.9, barColor: "from-red-500 to-red-400" },
  { name: "Viruses, Bacteria & Microbes",    percent: 99.9, barColor: "from-rose-500 to-rose-400" },
  { name: "Allergens, Pollen & Dust",         percent: 99.9, barColor: "from-amber-500 to-amber-400" },
  { name: "Volatile Organic Compounds (VOCs)", percent: 97.8, barColor: "from-emerald-500 to-emerald-400" },
  { name: "Pet Dander & Hair",                percent: 99.9, barColor: "from-sky-500 to-sky-400" },
];

const protections = [
  { icon: "ri-fire-line",       title: "Smoke",       desc: "Fine particulate matter from wildfire, tobacco, and combustion sources" },
  { icon: "ri-seedling-line",   title: "Allergens",   desc: "Seasonal pollen, dust mites, and animal dander" },
  { icon: "ri-virus-line",      title: "Pathogens",   desc: "Airborne viral particles, bacteria, and microbial contaminants" },
  { icon: "ri-restaurant-line", title: "Odors & VOCs", desc: "Volatile organic compounds, cooking odors, and pet-related smells" },
];

export default function StatsSection() {
  return (
    <section id="about" className="relative py-6 md:py-10 scroll-mt-20 bg-white">
      <div className="relative z-10 mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">

        {/* Header */}
        <div className="mb-6 md:mb-8 text-center max-w-3xl mx-auto">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-brand/10 text-xs font-extrabold tracking-[0.15em] uppercase text-brand mb-3">
            <i className="ri-shield-check-line text-sm" />
            Independently Tested
          </span>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-extrabold text-gray-900 leading-tight mb-3">
            Up to 99.9% Removal of Airborne Contaminants
          </h2>
        </div>

        {/* Two-column body */}
        <div className="grid lg:grid-cols-2 gap-4 md:gap-6 items-center">

          {/* Left — progress bars */}
          <div className="bg-[#FAF8F5] rounded-xl p-2.5 md:p-3 space-y-2">
            <p className="text-xs font-bold tracking-wider text-gray-600 uppercase mb-2">Removal Rate by Pollutant</p>
            {pollutants.map((p, i) => (
              <div key={i}>
                <div className="flex justify-between items-center mb-1">
                  <span className="text-sm font-bold text-gray-800">{p.name}</span>
                  <span className="text-sm font-black text-brand whitespace-nowrap ml-3">Up to {p.percent}%</span>
                </div>
                <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                  <div
                    className={`h-full bg-gradient-to-r ${p.barColor} rounded-full`}
                    style={{ width: `${p.percent}%` }}
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Right — protection grid */}
          <div>
            <div className="flex items-center gap-2 mb-2">
              <span className="w-2 h-2 rounded-full bg-brand shrink-0" />
              <span className="text-xs font-bold tracking-wider text-brand uppercase">Complete Protection</span>
            </div>
            <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-1">Multi-Threat Air Defense</h3>
            <p className="text-xs text-gray-700 font-bold leading-relaxed mb-3">
              From wildfire smoke to household germs — Airdog Destroys Pollutants standard purifiers miss.
            </p>
            <div className="grid grid-cols-2 gap-3">
              {protections.map((p, i) => (
                <div
                  key={i}
                  className="group bg-[#FAF8F5] rounded-lg p-2.5 md:p-3 border border-gray-100 hover:border-brand/20 hover:bg-white transition-all duration-300"
                >
                  <div className="w-9 h-9 rounded-md bg-brand/10 group-hover:bg-brand flex items-center justify-center mb-1.5 transition-all duration-300">
                    <i className={`${p.icon} text-brand group-hover:text-white text-base transition-colors duration-300`} />
                  </div>
                  <h4 className="text-sm font-bold text-gray-900 mb-0.5">{p.title}</h4>
                  <p className="text-[11px] text-gray-700 leading-snug font-bold">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}